(() => {
  const initialize = (root = document) => root.querySelectorAll('[data-st-collection]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const form = section.querySelector('[data-st-filter-form]');
    const toggle = section.querySelector('[data-st-filter-toggle]');
    const panel = section.querySelector('[data-st-filter-panel]');
    if (toggle && panel) {
      toggle.hidden = false;
      panel.hidden = Number(panel.dataset.active) === 0;
      toggle.addEventListener('click', () => {
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', String(!panel.hidden));
      });
      panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      });
    }
    form.querySelector('.st-sort-submit').hidden = true;
    section.querySelector('[data-st-sort]').addEventListener('change', () => form.requestSubmit());
    form.addEventListener('submit', event => {
      const min = form.querySelector('[aria-label="Minimum price"]');
      const max = form.querySelector('[aria-label="Maximum price"]');
      if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
        event.preventDefault(); max.setCustomValidity('Choose a maximum price above the minimum price.'); max.reportValidity();
        max.addEventListener('input', () => max.setCustomValidity(''), { once: true });
        min.addEventListener('input', () => max.setCustomValidity(''), { once: true });
        return;
      }
      form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
